var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.2901L11.58 10.8701C13.6558 8.41374 13.4258 4.75757 11.0585 2.58075C8.69123 0.40392 5.02864 0.480637 2.7546 2.75468C0.480553 5.02873 0.403836 8.69131 2.58066 11.0586C4.75749 13.4259 8.41365 13.6559 10.87 11.5801L14.29 15.0001L15 14.2901ZM7 12.0001C4.23858 12.0001 2 9.76151 2 7.00008C2 4.23866 4.23858 2.00008 7 2.00008C9.76142 2.00008 12 4.23866 12 7.00008C12 8.32617 11.4732 9.59794 10.5355 10.5356C9.59785 11.4733 8.32608 12.0001 7 12.0001Z",
    fill: "#354958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.36cbf10df36903c1a990444e5a5e351e.svg";
export { ForwardRef as ReactComponent };